<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/motor-types-edit/'+selected[0].idmotor_type)"
          >Edit</v-btn>
          <v-btn v-if=" selected.length > 0" text @click="deleteMotorType" color="red">Delete</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/motor-types-add')">
            <v-icon left dark>mdi-plus</v-icon>Create Motor Type
          </v-btn>
          
          <v-btn class="ma-2" color="primary" @click="$router.push('/motor-type-add-from-excell')">
            <v-icon left dark>mdi-plus</v-icon>Create Motor Types From Excell
          </v-btn>
          
          
          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Motor Types
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idmotor_type"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="motorTypes"
          :search="search"
        ></v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    selected: [],
    editMotorTypeId: 100,
    search: "",
    motorTypes: [],
    headers: [
      {
        text: "Type",
        align: "left",
        sortable: true,
        value: "type",
        width: 120
      },

      // { text: "Frequency", value: "frequency" },
      { text: "Voltage", value: "voltage" },
      { text: "Phase", value: "phase" },
      { text: "Fi_D_Max", value: "fi_d_max" },
      { text: "Degree Of Protection", value: "degree_of_protection" },
      { text: "Max. Water Temp (C)", value: "max_water_temp"},
    ],

    motorType: {
       idmotor_type: -1,
      type: "XSP 20",
      frequency: 50,
      phase: 3,
      voltage : "100-200",
      fi_d_max : 200,
      degree_of_protection : "IP 68",
      max_water_temp : "30",
    } 
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchMotorTypes();
  },
  methods: {
    deleteMotorType: function() {
      confirm("Are you sure you want to delete this item?") &&
        this.selected.forEach(this.deleteMotorTypeRequest);
      this.selected = [];
      console.log("selected bosaltildi.");
    },
    deleteMotorTypeRequest: function(motorType) {
      this.$http
        .get(this.$API_URL + "motor-type-delete?idmotor_type=" + motorType.idmotor_type)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchMotorTypes();
        });
    },
    fetchMotorTypes: function() {
      this.$http.get(this.$API_URL + "motor_types").then(result => {
        this.motorTypes = result.data;
      });
    }
  }
};
</script>
